import React, { useEffect, useRef, useState } from 'react'
import { FiEdit } from 'react-icons/fi';
import { validateSvg } from '../../../common';
import CouponsTable from './coupons/CouponsTable';
import { debounce } from 'lodash';
import { useCompaniesTableContext } from '../../../context/CompaniesTableContext';

const { REACT_APP_IMAGE_BASE_URL } = process.env;

function CompanyTableItem({ zoneId, company, categoriesQuery, setEditing, contactEmails, checked, companyIndex }) {
  const { totalUsedCoupons } = useCompaniesTableContext();

  const contactDetails = [company?.contactPerson, company?.contactMobile, company?.contactEmails?.join(', ')].filter(Boolean);
  const category = categoriesQuery?.categories?.find((category) => category._id === company.companyCategoryId);

  const [isCompanyHovered, setIsCompanyHovered] = useState(false);

  const [isInView, setIsInView] = useState(false);

  const [companyHeight, setCompanyHeight] = useState(0);

  const companyRef = useRef(null);

  useEffect(() => {
    const debouncedHandleScroll = debounce(([entry]) => {
      setIsInView(entry.isIntersecting);
    }, 500); // 500ms debounce (to make sure the user stopped scrolling)

    const observer = new IntersectionObserver(debouncedHandleScroll);

    if (companyRef.current) {
      observer.observe(companyRef.current);
    }

    return () => {
      if (companyRef.current) {
        observer.unobserve(companyRef.current);
      }
    };
  }, [company]);

  useEffect(() => {
    const resizeObserver = new ResizeObserver(debounce(entries => {
      for (let entry of entries) {
        if (entry.target === companyRef.current) {
          setCompanyHeight(entry.target.clientHeight);
        }
      }
    }, 100));

    if (companyRef.current) {
      resizeObserver.observe(companyRef.current);
    }

    return () => {
      if (companyRef.current) {
        resizeObserver.unobserve(companyRef.current);
      }
    };
  }, []);

  const handleMouseEnter = () => setIsCompanyHovered(true);
  const handleMouseLeave = () => setIsCompanyHovered(false);

  return (
    <>
      <tr
        ref={companyRef}
        className={`company company-row ${isCompanyHovered ? 'hovered' : ''}`}
        style={{
          position: 'relative'
        }}
      >
        <td
          className="company-info company-img"
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        >
          {company.logoURL ? <img alt="Företagslogotyp" src={`${REACT_APP_IMAGE_BASE_URL}${company.logoURL}`} /> : ''}
        </td>
        <td
          className="company-info company-name"
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        >
          <strong>{company.name}</strong>
          {contactDetails.length > 0 && <div>{contactDetails.join(', ')}</div>}
          {company?.notes && <div>{company.notes}</div>}
        </td>
        <td className="company-info company-tags">
          <div className="tags-container">
            {company.tags?.map((tag) => (
              <span
                key={tag._id}
                className="tag-badge"
                style={{ '--tag-color': tag.color }}
              >
                {tag.name}
              </span>
            ))}
          </div>
        </td>
        <td
          className="company-info company-category"
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        >
          <div>
            <div className='company-category-icon' dangerouslySetInnerHTML={{ __html: validateSvg(category?.iconPath) ? category.iconPath : '' }} />
            {category?.name}
          </div>
        </td>
        <td className='company-info company-edit' onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
          <span>
            {/* <span onClick={() => setEditing(company._id)}><FiEdit size={20} /></span> */}
            <button onClick={() => setEditing(company._id)}><FiEdit size={20} /></button>
            <p>{totalUsedCoupons[company._id]}</p>
          </span>
        </td>
      </tr>
      <CouponsTable
        key={`coupons-for-${company._id}`}
        company={company}
        contactEmails={contactEmails}
        checked={checked}
        zoneId={zoneId}
        isCompanyInView={isInView}
        companyHeight={companyHeight}
        companyIndex={companyIndex}
      />
    </>
  )
}

export default CompanyTableItem
